import { menuItemClasses } from '@mui/material';
import { palette } from '../global/palette';
import type { ComponentOverride } from '../types';

export const MuiMenuItem: ComponentOverride<'MuiMenuItem'> = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        '&:hover': {
          backgroundColor: palette.primary.main,
          color: palette.common.white,
        },
        [`&.${menuItemClasses.focusVisible}`]: {
          backgroundColor: palette.primary.main,
          color: palette.common.white,
        },
        [`&.${menuItemClasses.selected}`]: {
          backgroundColor: 'inherit',
          color: 'inherit',
        },
      },
    },
  },
};
